var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailInfoContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 10.626L12.7439 13.4821C14.6022 14.535 15.3874 14.535 17.2457 13.4821L22.2865 10.626",
    stroke: "#2177FE",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71462 16.0766C7.76229 18.3119 7.78612 19.4296 8.61091 20.2575C9.43569 21.0854 10.5836 21.1142 12.8794 21.1719C14.2943 21.2075 15.6953 21.2075 17.1102 21.1719C19.406 21.1142 20.5539 21.0854 21.3787 20.2575C22.2035 19.4296 22.2273 18.3119 22.275 16.0766C22.2903 15.3579 22.2903 14.6434 22.275 13.9247C22.2273 11.6894 22.2035 10.5718 21.3787 9.74384C20.5539 8.91592 19.406 8.88708 17.1102 8.8294C15.6953 8.79385 14.2943 8.79385 12.8793 8.82939C10.5836 8.88707 9.43569 8.91591 8.6109 9.74383C7.78612 10.5718 7.76229 11.6894 7.71462 13.9247C7.69929 14.6434 7.69929 15.3579 7.71462 16.0766Z",
    stroke: "#2177FE",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailInfoContainer);
export default __webpack_public_path__ + "static/media/MailInfoContainer.016de2611793a9a73d86d327b86d5661.svg";
export { ForwardRef as ReactComponent };